
/**
 * array data => table data
 * @param localeLang 语言
 * @param listData 原始数据
 * @param colCount 表格的列
 * @returns {{}}
 */
export const exchangeListToTable = (localeLang = '', listData = [], colCount = 4) => {
	const table = {};
	const isZhCN = localeLang === 'zh-CN';
	for (let i = 0; i < listData.length; i++) {
		const rowName = 'row' + (Math.floor(i / colCount + 1));
		// 数据清洗
		const {logo, country_cn_name, country_en_name} = listData[i];
		table[rowName] = [
			...table[rowName] || [],
			{
				logo,
				countryName: isZhCN ? country_cn_name : country_en_name
			}
		]
		;
	}
	return table;
};
